"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const hopper_style_1 = __importDefault(require("../hopper.style"));
const hopper_action_1 = __importDefault(require("../hopper.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const hopper_column_1 = __importDefault(require("../hopper.column"));
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const modal_1 = require("components/molecules/modal");
const react_router_dom_1 = require("react-router-dom");
const authorization_1 = require("utils/authorization");
const DailySummaryHopper = () => {
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const { isError, isLoading, dataStates, summaryMode, errorMessage, dataGrid } = (0, store_1.useAppSelector)((state) => state.dailySummary.hopper);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isExternal = (0, authorization_1.isUserExternal)(userData.contractor_name);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Daily Summary', 'Hopper');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                if (isExternal) {
                    const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: {
                            logic: 'and',
                            filters: [{ field: 'contractor_name', operator: 'eq', value: userData.contractor_name }]
                        } });
                    dispatch(hopper_action_1.default.getDataGrid({ dataStates: newDataStates, summaryMode }));
                }
                else {
                    dispatch(hopper_action_1.default.getDataGrid({ dataStates, summaryMode }));
                }
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isExternal, isAuthorized]);
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(hopper_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(hopper_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(hopper_action_1.default.getDataGrid({ dataStates: newDataStates, summaryMode }));
    };
    const onSortChange = (e) => {
        dispatch(hopper_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        dispatch(hopper_action_1.default.getDataGrid({ dataStates: newDataStates, summaryMode }));
    };
    const columnsRender = isExternal
        ? hopper_column_1.default.map(item => {
            if (item.field === 'contractor_name') {
                return Object.assign(Object.assign({}, item), { filterable: false });
            }
            else {
                return item;
            }
        })
        : hopper_column_1.default;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { isMTD: true, isToday: true, title: 'Hopper', theme: appTheme, isLoading: isLoading, isSummary: true, summaryMode: summaryMode, onMTD: () => dispatch(hopper_action_1.default.onClickSummaryMode({ summaryMode: 'mtd' })), onToday: () => dispatch(hopper_action_1.default.onClickSummaryMode({ summaryMode: 'today' })) }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { zIndex: 10 }, errorMessage: errorMessage, onClose: () => dispatch(hopper_action_1.default.onCloseError()) }), (0, jsx_runtime_1.jsx)(grid_1.default, { pageable: true, sortable: true, dataGrid: dataGrid, sort: dataStates.sort, scrollable: 'scrollable', columns: columnsRender, dataStates: dataStates, style: hopper_style_1.default.gridHeight, onSortChange: onSortChange, onFilterChange: onFilterChange, onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v) })] }));
};
exports.default = DailySummaryHopper;
